import EventWithSeasonMapper from './event-with-season-mapper';
import SeasonModel from '../season/season-model';

const EventWithSeasonModel = {
    mapper: EventWithSeasonMapper,

    count: {
        type: Number,
    },

    seasons: {
        model: SeasonModel,
        type: Array,
    },
};

export default EventWithSeasonModel;
